<template>
  <div class="member-center-bg">
    <div class="member-center-container">
      <div class="member-center-main">
        <!-- 左侧：个人信息和文创中心 -->
        <div class="member-left">
          <el-card class="profile-card">
            <div class="profile-header">
              <img :src="profilePic" alt="头像" class="profile-avatar" />
              <div class="profile-info">
                <div class="profile-name-row">
                  <span class="profile-name">{{ greeting }}{{ userInfo.name }}</span>
                  <span class="profile-title">{{ userInfo.title }}</span>
                  <span class="profile-courses">课题数：{{ userInfo.courseCount }}</span>
                </div>
              </div>
              <div class="profile-vip">
                <span class="vip-level">会员等级：{{ userInfo.membershipLevel }}</span>
                <el-button type="primary" class="vip-btn">升级会员</el-button>
              </div>
            </div>
          </el-card>
          <el-card class="creative-center-card">
            <div class="creative-title">文创中心</div>
            <div class="creative-grid">
              <div v-for="(item, idx) in creativeItems" :key="idx" class="creative-item">
                <img :src="item.image" class="creative-img" />
                <div class="creative-name">{{ item.name }}</div>
              </div>
            </div>
          </el-card>
        </div>
        <!-- 右侧：会员权益和历史记录 -->
        <div class="member-right">
          <el-card class="benefits-card">
            <div class="benefits-title">会员权益</div>
            <div class="benefits-row">
              <div v-for="benefit in benefits" :key="benefit.id" class="benefit-item" @click="goBenefit(benefit)">
                <i :class="benefit.icon" class="benefit-icon"></i>
                <div class="benefit-title">{{ benefit.title }}</div>
              </div>
            </div>
          </el-card>
          <el-card class="history-card">
            <div class="history-title">历史记录</div>
            <div class="history-grid">
              <div v-for="(record, idx) in historyData" :key="idx" class="history-item">
                <img :src="record.image" class="history-img" />
                <div class="history-info">
                  <div class="history-filename">{{ record.filename }}</div>
                  <div class="history-date">日期：{{ record.date }}</div>
                </div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      profilePic: '/img/ren1.jpg',
      userInfo: {
        name: '王老师',
        title: '高级教师',
        courseCount: 12,
        membershipLevel: '高级会员',
      },
      benefits: [
        { id: 1, icon: 'el-icon-document', title: '课程资源下载', route: 'ResourceDownload' },
        { id: 2, icon: 'el-icon-tickets', title: '教学模板', route: 'TeachingTemplate' },
        { id: 3, icon: 'el-icon-video-camera', title: '视频课程观看', route: 'VideoCourses' },
      ],
      creativeItems: [
        { name: '机械结构', image: '/img/creative1.jpg' },
        { name: '卡通人物', image: '/img/creative2.jpg' },
        { name: '创意动物', image: '/img/creative3.jpg' },
        { name: '建筑结构', image: '/img/creative4.jpg' },
      ],
      historyData: [
        { image: '/img/his1.jpg', filename: '下载课程资料.pdf', date: '2024-10-01' },
        { image: '/img/his2.jpg', filename: '下载课程资料.pdf', date: '2024-10-01' },
        { image: '/img/his3.jpg', filename: '下载课程资料.pdf', date: '2024-10-01' },
        { image: '/img/his4.jpg', filename: '下载课程资料.pdf', date: '2024-10-01' },
        { image: '/img/his5.jpg', filename: '下载课程资料.pdf', date: '2024-10-01' },
        { image: '/img/his6.jpg', filename: '下载课程资料.pdf', date: '2024-10-01' },
      ],
    };
  },
  computed: {
    greeting() {
      const hour = new Date().getHours();
      if (hour >= 5 && hour < 8) return '早上好，';
      if (hour >= 8 && hour < 11) return '上午好，';
      if (hour >= 11 && hour < 13) return '中午好，';
      if (hour >= 13 && hour < 17) return '下午好，';
      if (hour >= 17 && hour < 19) return '傍晚好，';
      if (hour >= 19 && hour < 24) return '晚上好，';
      return '凌晨好，';
    }
  },
  methods: {
    goBenefit(benefit) {
      // 通过 $emit 通知父组件切换页面
      if (benefit && benefit.route) {
        this.$emit('switch-view', benefit.route);
      }
    }
  }
};
</script>

<style scoped>
.member-center-bg {
  min-height: 100vh;
  /* background: #f5faff; */
  padding: 24px 0;
}
.member-center-container {
  max-width: 1557px;
  margin: 0 auto;
  padding: 0 24px;
}
.member-center-main {
  display: flex;
  gap: 24px;
}
.member-left {
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.member-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.profile-card {
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 24px;
}
.profile-header {
  display: flex;
  align-items: center;
  gap: 24px;
}
.profile-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.profile-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
}
.profile-name-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}
.profile-name {
  font-size: 20px;
  font-weight: bold;
  color: #222;
}
.profile-title {
  font-size: 14px;
  color: #888;
}
.profile-courses {
  font-size: 14px;
  color: #666;
}
.profile-vip {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}
.vip-level {
  font-size: 14px;
  color: #000000;
}
.vip-btn {
  padding: 4px 18px;
  height: 35px;
  border-radius: 4px;
  width: 125px;
}
.creative-center-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 16px;
}
.creative-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 12px;
}
.creative-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.creative-item {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.03);
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: box-shadow 0.2s;
}
.creative-item:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.10);
}
.creative-img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  border-radius: 6px;
}
.creative-name {
  margin-top: 6px;
  font-size: 13px;
  color: #222;
  text-align: center;
}
.benefits-card {
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 24px;
}
.benefits-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 18px;
}
.benefits-row {
  display: flex;
  gap: 16px;
  justify-content: space-between;
}
.benefit-item {
  flex: 1;
  background: #f6faff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px 0 10px 0;
  transition: box-shadow 0.2s, background 0.2s;
  cursor: pointer;
}
.benefit-item:hover {
  background: #eaf6ff;
  box-shadow: 0 2px 8px rgba(64,158,255,0.08);
}
.benefit-icon {
  font-size: 32px;
  color: #409EFF;
  margin-bottom: 8px;
}
.benefit-title {
  font-size: 15px;
  color: #222;
  text-align: center;
}
.history-card {
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 24px;
}
.history-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 18px;
}
.history-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.history-item {
  display: flex;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.03);
  padding: 10px;
  align-items: center;
  gap: 12px;
}
.history-img {
  width: 54px;
  height: 54px;
  border-radius: 8px;
  object-fit: cover;
}
.history-info {
  flex: 1;
}
.history-filename {
  font-size: 12px;
  color: #222;
  text-align: justify;
  white-space: nowrap;
}
.history-date {
  font-size: 13px;
  color: #888;
  margin-top: 4px;
  text-align: justify;
  white-space: nowrap;
}
@media (max-width: 1200px) {
  .member-center-main {
    flex-direction: column;
  }
  .member-left, .member-right {
    width: 100%;
  }
}
</style>
